import { jsx } from "react/jsx-runtime";
import { TextButton, Button as Button$1, IconSmartphoneOutline, IconSmartphone, IconPointerUpOutline, IconPointerUp, IconPointerDownOutline, IconPointerDown, IconPlayOutline, IconPlayCircleOutline, IconPlayCircle, IconPlay, IconMailOutline, IconMail, IconArrowUpOutline, IconArrowRightOutline, IconArrowLeftOutline, IconArrowDownOutline } from "@zillow/constellation";
import { event } from "@zillow/universal-analytics";
import { yieldCallback } from "@zillow/yield-callback";
import { usePageProps, getButtonMinWidth, getCmsInfoForPage } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { withTrigger } from "../../util/helpers.esm.js";
import { usePopulateParamPlaceHolders } from "../../util/populateParamPlaceholders.esm.js";
const Components = {
  Button: Button$1,
  TextButton
};
const IconList = {
  IconArrowDownOutline,
  IconArrowLeftOutline,
  IconArrowRightOutline,
  IconArrowUpOutline,
  IconMail,
  IconMailOutline,
  IconPlay,
  IconPlayCircle,
  IconPlayCircleOutline,
  IconPlayOutline,
  IconPointerDown,
  IconPointerDownOutline,
  IconPointerUp,
  IconPointerUpOutline,
  IconSmartphone,
  IconSmartphoneOutline
};
const BlockButton = (props) => {
  const pageProps = usePageProps();
  const {
    attrs,
    index
  } = props;
  const {
    content = "Button Text",
    link,
    component = "Button",
    icon,
    fixedWidth,
    size = "md",
    style,
    ...restAttrs
  } = attrs;
  const ButtonComponent = Components[component];
  const IconComponent = icon ? IconList[icon] : null;
  const attributes = {
    size,
    buttonType: "primary",
    iconPosition: "end",
    ...restAttrs,
    // Override string icon value with component
    icon: IconComponent ? /* @__PURE__ */ jsx(IconComponent, {}) : void 0,
    // Apply calculated minWidth based on fixedWidth + size
    style: {
      ...style,
      minWidth: getButtonMinWidth({
        fixedWidth,
        size,
        component
      })
    }
  };
  const href = usePopulateParamPlaceHolders((link == null ? void 0 : link.url) || link);
  if (link) {
    attributes.as = "a";
    attributes.href = href;
    attributes.target = (link == null ? void 0 : link.opensInNewTab) ? "_blank" : void 0;
  }
  const ButtonWithTrigger = withTrigger(ButtonComponent);
  return /* @__PURE__ */ jsx(ButtonWithTrigger, { triggerLink: (link == null ? void 0 : link.url) || link, type: "button", ...attributes, onMouseEnter: () => {
    event({
      // https://dataportal.zillowgroup.net/event-registry/2049
      envelope: {
        event_type_id: "2049",
        event_type_version_id: "1",
        event_template_id: "126",
        event_template_version_id: "1"
        // Master ID: 2284.2.126.1
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_button",
        trigger_object_nm: "no_trigger_object"
      },
      semantic: {
        semantic_event_nm: "cms_hover"
      },
      cms_info: {
        block_id: attributes.id || "",
        block_type_cd: "button",
        block_displayed_txt: content,
        block_target_url: (link == null ? void 0 : link.url) || link,
        block_target_window_txt: (link == null ? void 0 : link.opensInNewTab) ? "_blank" : "",
        ...getCmsInfoForPage(pageProps)
      }
    });
  }, onClick: yieldCallback((e) => {
    event({
      // https://dataportal.zillowgroup.net/event-registry/2048
      envelope: {
        event_type_id: "2048",
        event_type_version_id: "1",
        event_template_id: "126",
        event_template_version_id: "1"
        // Master ID: 2284.2.126.1
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_button",
        trigger_object_nm: "no_trigger_object"
      },
      semantic: {
        semantic_event_nm: "cms_click"
      },
      cms_info: {
        block_id: e.target.id || "",
        block_type_cd: "button",
        block_displayed_txt: e.target.textContent,
        block_target_url: (link == null ? void 0 : link.url) || link,
        block_target_window_txt: (link == null ? void 0 : link.opensInNewTab) ? "_blank" : "",
        ...getCmsInfoForPage(pageProps)
      }
    });
  }), children: content }, index);
};
BlockButton.propTypes = {
  attrs: PropTypes.shape({
    content: PropTypes.string,
    link: PropTypes.string,
    component: PropTypes.string,
    fixedWidth: PropTypes.bool,
    size: PropTypes.oneOf(["sm", "md", "lg"]),
    icon: PropTypes.string,
    style: PropTypes.object
  }),
  index: PropTypes.number
};
const Button = withTrigger(BlockButton);
export {
  Button as default
};
